export default {
    namespaced: true,
    state: {
        batch: {},
        // batchAll: {
        //     fotografie: {},
        //     videografie: {}
        // }
    },
    mutations: {
        clearBatch: (state, batch) => {
            state.batch = {};
            // state.batchAll.fotografie = {};
            // state.batchAll.videografie = {};
        },
        setBatch: (state, batch, type) => {
            state.batch = batch;

            // if(type == 'fotografie') {
            //     state.batchAll.fotografie = batch;
            // }
            //
            // if(type == 'videografie') {
            //     state.batchAll.videografie = batch;
            // }
        }
    },
    actions: {

        getBatch(context, type) {

            // if(Object.keys(context.state.batch).length > 0) return false;

            context.commit('clearBatch');

            var now = null;

            var params = new URLSearchParams(window.location.search.substring(1));

            if(params.get("now")) {

                now = params.get("now");
                now = now.replace("_"," ");
                now = now.replace(",",":");

                localStorage.setItem("now", now);
            }

            this.$axios.get('/request.php?type=' + type + '&now=' + localStorage.getItem("now") + '&no=' + params.get("no"), {
            })
            .then(response => {

                if(response.data) {

                    context.commit('setBatch', response.data, type);
                }
                return response;
            });
        },
    },
    getters: {

        categories: (state, getters) => {

            return state.batch.categories
        },

        knowHow: (state, getters) => {

            return state.batch.knowHow
        },

        rank: (state, getters) => {

            return state.batch.rank
        },

        rankButtonText: (state, getters) => {

            if(state.batch.final) {

                return 'Clasament FINAL';
            }
            else {

                return 'Clasament intermediar';
            }
        }
    }
}
